import React from 'react';
import { Pagination } from '../../plugins/pagination/components/Pagination.js';
import '@elliemae/ds-classnames';
import '../../plugins/pagination/components/Paginator.js';
import 'react-pagify';
import 'segmentize';
import '../../plugins/pagination/components/PerPageDropdown.js';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'memoize-one';
import '@elliemae/ds-utilities/utils';
import '@elliemae/ds-basic/form/ComboBox';

var addOptionalFooterComponents = function addOptionalFooterComponents(_ref) {
  var grid = _ref.grid,
      rows = _ref.rows;
  var _grid$props = grid.props,
      maxPerPage = _grid$props.maxPerPage,
      minPerPage = _grid$props.minPerPage,
      paginated = _grid$props.paginated,
      paginationStep = _grid$props.paginationStep,
      pagination = grid.state.pagination,
      _grid$actions = grid.actions,
      onPerPage = _grid$actions.onPerPage,
      onPageSelect = _grid$actions.onPageSelect;
  if (!paginated) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Pagination, {
    maxPerPage: maxPerPage,
    minPerPage: minPerPage,
    onPageSelect: onPageSelect,
    onPerPage: onPerPage,
    paginationStep: paginationStep,
    paginated: rows,
    pagination: pagination
  }));
};

export default addOptionalFooterComponents;
//# sourceMappingURL=addOptionalFooterComponents.js.map
